module.exports = __webpack_public_path__ + "static/d1537fbd27-b17d23d330fddb9d8973262d6c39a1d6.jpg";